export default {
  getActiveProjectData(state: any) {
    return state.project.projects.find((item: any) => item.slug === state.project.activeProject)
  }
}
